import React, { useState, useContext } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { validateEmail } from "../../../_helpers/validators";
import {
  sigin_user_action,
  google_login_action,
  microsoft_login_action,
} from "../../../redux/_actions";
import { useGoogleLogin } from "@react-oauth/google";
import {
  regsiter_onesignal_client_token_for_notification_action,
  set_onesignal_device_token_for_notification_action,
} from "../../../redux/_actions/common/onesignal.actions";
import { useSelector } from "react-redux";
import { AuthContext } from "../../../_hooks/useAuthContext";

function useSignin(props) {
  const { setUser } = useContext(AuthContext);

  //initial states
  const [formData, setformData] = useState({});
  const [formInputsError, setFormInputsError] = useState({});
  const [loading, setloading] = useState(false);
  const [showPassword, setshowPassword] = useState(false);
  const [googleLoader, setGoogleLoader] = useState(false);
  const [microsoftLoader, setMicrosoftLoader] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const dispatch = useDispatch();

  const { oneSignalDeviceId } = useSelector(
    (state) => state.set_onesignal_device_token_for_notification_reducer
  );

  React.useEffect(() => {
    setformData({
      email: "",
      password: "",
    });
  }, []);

  React.useEffect(() => {
    if (isAuthenticated && inProgress === InteractionStatus.None) {
      instance
        .acquireTokenSilent({
          account: accounts[0],
          scopes: ["User.Read"],
        })
        .then((response) => {
          if (response?.accessToken) {
            callMicroSoftLoginApi(response?.accessToken);
          }
        });
    }
  }, [isAuthenticated, inProgress]);

  //one signal device token init
  React.useEffect(() => {
    callOneSignalDeviceToken();
  }, []);

  const callOneSignalDeviceToken = async () => {
    await dispatch(set_onesignal_device_token_for_notification_action());
  };

  //set states on input change
  const onInputChange = (value, key) => {
    let data = formData;
    data[key] = value;
    setformData(data);
  };

  // submit form
  const onSubmitClick = async (e) => {
    e.preventDefault();
    setloading(true);

    setFormInputsError({});

    if (validateForm()) {
      const loginData = await dispatch(sigin_user_action(formData));
      setUser(loginData);
      checkNavigate(loginData);
    }
    setloading(false);
  };

  //navigate to screens
  const checkNavigate = async (loginData) => {
    if (loginData !== undefined) {
      let navigateRoute = location?.state && location.state?.navigateRoute;
      const role = loginData?.user && loginData.user?.role;
      if (oneSignalDeviceId) {
        const data = {
          registration_id: oneSignalDeviceId,
          type: "web",
          device_id: oneSignalDeviceId.substr(0, 150),
          active: true,
        };
        if (loginData.msg === undefined) {
          await dispatch(
            regsiter_onesignal_client_token_for_notification_action(data)
          );
        }
      }

      if (role === null) {
        window.location.reload();
      }

      // dashboard
      else if (role === "hiring_manager") {
        if (
          loginData?.user &&
          loginData.user?.user_meta_info &&
          loginData.user.user_meta_info?.company === null
        ) {
          navigate("/hiring-manager-onboard");
        } else if (navigateRoute) {
          navigate(navigateRoute);
        } else {
          navigate("/dashboard/hiring-manager");
        }
      } else if (role === "candidate") {
        if (
          loginData?.user &&
          loginData.user?.user_meta_info &&
          loginData.user.user_meta_info?.phone === null
        ) {
          navigate("/candidate-details");
        } else if (navigateRoute) {
          navigate(navigateRoute, { state: location?.state });
        } else {
          navigate("/dashboard/candidate");
        }
      } else if (role === "mentor") {
        if (
          loginData?.user &&
          loginData.user?.user_meta_info &&
          loginData.user.user_meta_info?.phone === null
        ) {
          navigate("/mentor-onboard");
        } else if (navigateRoute) {
          navigate(navigateRoute);
        } else {
          navigate("/dashboard/mentor");
        }
      } else if (role === "recruiter") {
        navigate("/dashboard/recruiter");
      } else {
        let form_errors = {
          formSubmitError:
            loginData.msg && loginData.msg !== ""
              ? loginData.msg && loginData.msg
              : "Can not login at this time.",
        };

        setFormInputsError(form_errors);
      }
    } else {
      let form_errors = {
        formSubmitError: "Can not login at this time.",
      };

      setFormInputsError(form_errors);
    }
  };

  //change password show button

  const handleShowPassword = (key) => {
    setshowPassword(!showPassword);
  };

  //validate form

  const validateForm = () => {
    let form_errors = {};

    //validate email

    if (formData.email.length === 0) {
      form_errors = {
        email: "Email cannot be empty",
      };

      setFormInputsError(form_errors);

      return false;
    }

    if (!validateEmail(formData.email)) {
      form_errors = {
        email: "Enter valid email",
      };

      setFormInputsError(form_errors);

      return false;
    }

    // validate password

    if (formData.password.length === 0) {
      form_errors = {
        password: "Field can not be empty",
      };

      setFormInputsError(form_errors);

      return false;
    }

    return true;
  };

  // google login click

  const google_login = useGoogleLogin({
    // scope: ["https://www.googleapis.com/auth/calendar"],
    // access_type: "offline",
    // include_granted_scopes: true,
    onSuccess: (codeResponse) => successResponseGoogle(codeResponse),

    onError: (response) => failureResponseGoogle(response),
  });

  //google login success/failure

  const successResponseGoogle = async (response) => {
    const token = { access_token: response.access_token };

    if (token) {
      setGoogleLoader(true);

      const loginData = await dispatch(google_login_action(token));
      setUser(loginData);
      checkNavigate(loginData);
    }

    setGoogleLoader(false);
  };

  const failureResponseGoogle = (response) => {
    if (response.error !== "popup_closed_by_user")
      if (response.details.includes("Cookies are not enabled")) {
        let form_errors = {
          formSubmitError: "Please enable cookies.",
        };

        setFormInputsError(form_errors);
      } else {
        let form_errors = {
          formSubmitError: "",
        };

        setFormInputsError(form_errors);
      }
  };

  const microsoftLogin = () => {
    instance.loginRedirect();
  };

  const callMicroSoftLoginApi = async (response) => {
    const token = { access_token: response };

    if (token) {
      setMicrosoftLoader(true);

      const loginData = await dispatch(microsoft_login_action(token));
      setUser(loginData);
      checkNavigate(loginData);
    }

    setMicrosoftLoader(false);
  };
  return {
    formInputsError,

    loading,

    showPassword,

    googleLoader,
    microsoftLoader,

    onInputChange,

    onSubmitClick,

    handleShowPassword,

    google_login,

    microsoftLogin,
  };
}

export default useSignin;
